var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: "添加装卸",
            visible: _vm.dialogVisible,
            width: "1000px"
          },
          on: { close: _vm.close }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                "label-width": "50",
                "label-position": "left",
                model: _vm.ruleForm,
                rules: _vm.rules,
                "validate-on-rule-change": false
              }
            },
            _vm._l(_vm.ruleForm, function(value, key, index) {
              return _c("handling-card", {
                key: index,
                ref: "handlingCard",
                refInFor: true,
                attrs: { cardKey: 0, ruleForm: _vm.ruleForm, rules: _vm.rules },
                on: {
                  goodsDel: _vm.goodsDel,
                  addToCommonUse: _vm.addToCommonUse,
                  addGoodsSuccess: _vm.addGoodsSuccess,
                  addGoodsValidate: _vm.addGoodsValidate
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3a2d92da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3a2d92da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/components/handlingWrapper/components/addHandlingDialog/index.vue
// module id = null
// module chunks = 